import { render, staticRenderFns } from "./AddAccountDetailsModal.vue?vue&type=template&id=2d3b6784&scoped=true&"
import script from "./AddAccountDetailsModal.vue?vue&type=script&lang=js&"
export * from "./AddAccountDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddAccountDetailsModal.vue?vue&type=style&index=0&id=2d3b6784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3b6784",
  null
  
)

component.options.__file = "AddAccountDetailsModal.vue"
export default component.exports